<template>
  <div>
    <b-breadcrumb class="text-truncated" :items="items"></b-breadcrumb>
    <template v-if="!mandat.ID && loaded">
      <b-row>
        <b-col lg="12">
          <b-alert show>Mandat inexistant</b-alert>
        </b-col>
      </b-row>
    </template>

    <div
      v-if="busy"
      class="text-center"
      style="
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 10000;
      "
    >
      <b-spinner label="Spinning"></b-spinner>
    </div>
    <b-row v-if="loaded && mandat.ID" class="mx-0 mb-3">
      <b-col
        lg="12"
        style="
          top: 47px;
          z-index: 1025;
          background-color: var(--white);
          padding-top: 0px;
          padding-bottom: 5px;
        "
        class="mb-3 position-sticky shadow"
      >
        <h4 class="d-none d-lg-block">
          Mandat <span class="text-danger">{{ mandat.ID.value }}</span>
        </h4>
        <hr class="mt-0 d-none d-lg-block" />
        <template v-if="$store.getters.isAdmin">
          <b-button
            icon
            size="sm"
            v-if="mandat.status.value == 'unused'"
            :to="{ name: 'warrantOpen', params: { id: mandat.ID.value } }"
            class="mr-3"
            title="Ouvrir le mandat"
          >
            <b-icon-play-fill></b-icon-play-fill>
          </b-button>
          <b-button
            icon
            size="sm"
            v-else-if="mandat.status.value != 'closed'"
            @click="save"
            title="Enregistrer les modifications"
            variant="success"
            class="mr-3"
          >
            <b-icon-upload></b-icon-upload>
          </b-button>
          <b-button
            icon
            size="sm"
            v-if="mandat.status.value == 'open'"
            :disabled="!mandat.canBeSuspended"
            @click="$bvModal.show('modal-suspend')"
            title="Mettre le mandat en pause"
            class="mr-3"
          >
            <b-icon-pause-fill></b-icon-pause-fill>
          </b-button>
          <b-button
            icon
            size="sm"
            v-if="
              mandat.status.value == 'stopped' ||
              mandat.status.value == 'closed'
            "
            @click="reopen"
            class="mr-3"
            title="Rouvrir le mandat"
          >
            <b-icon-play-fill></b-icon-play-fill>
          </b-button>
          <b-button
            icon
            size="sm"
            variant="danger"
            v-if="mandat.status.value == 'open'"
            title="Clôturer le mandat"
            class="mr-3"
            @click="$bvModal.show('modal-stop1')"
          >
            <b-icon-stop-fill></b-icon-stop-fill>
          </b-button>
          <b-button
            @click="$bvModal.show('modal-rc')"
            icon
            size="sm"
            variant="secondary"
            title="Renseignement client"
            class="mr-3"
          >
            <b-icon-question-circle-fill></b-icon-question-circle-fill>
          </b-button>
        </template>

        <b-modal
          id="modal-suspend"
          @ok="suspend"
          @cancel="$bvModal.hide('modal-suspend')"
          cancel-title="Annuler"
        >
          <template #modal-title> Suspendre le mandat </template>
          <b-row>
            <mh-input
              mhClass="col-12"
              field="note_suspend"
              :table="mandat"
            ></mh-input>
            <mh-input mhClass="col-12" field="popUpAgenda" :table="mandat">
            </mh-input>
          </b-row>
        </b-modal>

        <b-modal
          size="xl"
          id="modal-stop1"
          @show="loadstoplist()"
          @ok="$bvModal.show('modal-stop2')"
          @cancel="$bvModal.hide('modal-stop1')"
          cancel-title="Annuler"
          ok-title="Étape suivante"
        >
          <template #modal-title>Clôturer le mandat (1)</template>
          <b-row>
            <b-col lg="3" md="12">
              <b-form-group
                class="my-0"
                label="Date de cloture"
                label-size="sm"
                label-class="mb-0"
              >
                <b-datepicker
                  name="Date de clôture"
                  locale="fr-BE"
                  v-model="date_cloture"
                  label-no-date-selected="--"
                >
                </b-datepicker>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <mh-input
              mhClass="col-lg-12"
              field="note_cloture"
              :table="mandat"
            ></mh-input>

            <b-col lg="12">
              <b-form-group
                class="my-0"
                label="Raisons"
                label-size="sm"
                label-class="mb-0"
              >
                <b-form-select
                  v-model="reasonsSelected"
                  :options="stopList"
                  multiple
                  :select-size="15"
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
        </b-modal>
        <b-modal size="xl" id="modal-stop2" @show="getClotureBody()">
          <template #modal-title>Clôturer le mandat (2)</template>
          <template #modal-footer>
            <b-button
              @click="
                $bvModal.hide('modal-stop2') || $bvModal.show('modal-stop1')
              "
              >Étape précédente</b-button
            >
            <b-button @click="$bvModal.hide('modal-stop2') || stop(false)"
              >Clôturer</b-button
            >
            <b-button @click="$bvModal.hide('modal-stop2') || stop(true)"
              >Clôturer et envoyer un email au client
            </b-button>
          </template>
          <b-row>
            <b-col lg="12">
              <b-form-group
                class="my-0"
                label="Corps du texte"
                label-size="sm"
                label-class="mb-0"
              >
                <b-textarea
                  debounce="1000"
                  rows="10"
                  v-model="cloture_body"
                ></b-textarea>
              </b-form-group>
            </b-col>
            <b-col lg="12">
              <object
                style="width: 100%; height: 1000px"
                :data="cloturePdfPath()"
                type="application/pdf"
              >
                <embed :src="cloturePdfPath()" type="application/pdf" />
              </object>
            </b-col>
          </b-row>
        </b-modal>
        <b-modal
          id="modal-rappel-avocat"
          size="xl"
          title="Rappel avocat"
          hide-footer
        >
          <RappelAvocatMail
            @close="$bvModal.hide('modal-rappel-avocat')"
            :mandat_id="mandat.ID.value"
          >
          </RappelAvocatMail>
        </b-modal>
        <b-modal
          id="modal-rc"
          size="xxl"
          title="Renseignement client"
          hide-footer
        >
          <RenseignementClient
            @close="$bvModal.hide('modal-rc')"
            :mandat="mandat"
          >
          </RenseignementClient>
        </b-modal>
        <b-button
          @click="openEvolution()"
          size="sm"
          icon
          variant="info"
          class="mr-3"
          title="Évolution du principal, paiements et solde"
        >
          <i class="fas fa-chart-line-down"></i>
        </b-button>

        <b-button
          :href="
            'mailto:' +
            mandat.debiteur.email.value +
            '?bcc=info@cabinetdegreft.be&subject=Concernant votre dossier #' +
            mandat.ID.value
          "
          :disabled="mandat.debiteur.email.value == ''"
          class="mr-3"
          icon
          size="sm"
          title="Email"
          ><i class="fas fa-envelope"></i
        ></b-button>

        <b-button
          icon
          size="sm"
          v-if="$store.getters.isAdmin"
          @click="$bvModal.show('modal-agenda')"
          class="mr-3"
          :disabled="mandat.status.value == 'closed'"
          title="Agenda"
        >
          <b-icon-calendar-check></b-icon-calendar-check>
        </b-button>
        <b-button
          v-if="$store.getters.isAdmin"
          title="Modifier les paramètres d'indemnités du mandat"
          icon
          size="sm"
          @click="$bvModal.show('editIndemnities')"
          class="mr-3"
          ><i class="far fa-money-check-edit"></i
        ></b-button>
        <b-button
          v-if="$store.getters.isAdmin && (mandat.creancier.envoi_accuses.value == 'yes')"
          title="Accusé de réception"
          icon
          @click="accuse()"
          variant="secondary"
          class="mr-3"
          size="sm"
        >
          <b-icon-check-circle-fill></b-icon-check-circle-fill>
        </b-button>
        <b-button
          v-if="$store.getters.isAdmin"
          title="Mise en demeure Avocat / Huissier"
          icon
          class="mr-3"
          @click="iconActionMD"
          size="sm"
        >
          <b-icon-exclamation-triangle-fill></b-icon-exclamation-triangle-fill>
        </b-button>
        <b-button
          v-if="$store.getters.isAdmin"
          title="Assignation"
          icon
          class="mr-3"
          @click="iconActionAssignation()"
          size="sm"
        >
          <b-icon-hammer></b-icon-hammer>
        </b-button>
        <b-button
          v-if="$store.getters.isAdmin"
          variant="success"
          title="Mandat précédent"
          class="ml-3"
          icon
          size="sm"
          :to="{
            name: 'warrantView',
            params: { id: mandat.navigation.previous },
          }"
          :disabled="!mandat.navigation.previous"
        >
          <b-icon-arrow-left-circle-fill></b-icon-arrow-left-circle-fill>
        </b-button>
        <b-button
          v-if="$store.getters.isAdmin"
          variant="success"
          title="Mandat suivant"
          class="ml-3"
          icon
          size="sm"
          :to="{
            name: 'warrantView',
            params: { id: mandat.navigation.next },
          }"
          :disabled="!mandat.navigation.next"
        >
          <b-icon-arrow-right-circle-fill></b-icon-arrow-right-circle-fill>
        </b-button>
        <b-button @click="cancelWarrant()" v-if="$store.getters.isSuperAdmin && mandat.cancelable" variant="danger" class="ml-4" icon size="sm" title="Annuler ce mandat">
          <b-icon-trash-fill></b-icon-trash-fill>
        </b-button>
      </b-col>
      <b-col class="m-0">
        <b-row>
          <b-col lg="12">
            <b-alert v-if="mandat.toCheck.value == 'yes'" show variant="info">
              <p>
                Ce mandat a été créé par un client. Vérifiez les informations et
                lorsque vous avez terminé, veuillez valider ce mandat.
              </p>
              <b-button @click="validateWarrant()" variant="success"
                >Valider ce mandat</b-button
              >
            </b-alert>
            <b-alert
              variant="danger"
              show
              v-if="mandat.status.value !== 'open'"
            >
              Ce mandat est {{ mandat.status.i18n }}
              <span v-if="mandat.status.value == 'closed'"
                >(vous ne pouvez modifier ce mandat)</span
              >
              <span
                v-if="
                  mandat.status.value == 'stopped' &&
                  mandat.popUpAgenda.value &&
                  toDate(mandat.popUpAgenda.value)
                "
              >
                - Mis à l'agenda à la date du
                {{ toDate(mandat.popUpAgenda.value) }}</span
              >
              <span v-else> - Sans date à l'agenda </span>
            </b-alert>
          </b-col>
          <b-col lg="12">
            <b-row
              v-if="
                mandat.note_cloture.value !== '' &&
                mandat.status.value == 'closed'
              "
              class="mb-3"
            >
              <b-col lg="12">
                <b-card class="bg-light shadow">
                  <b-card-title title-tag="h6">
                    Note de clotûre :
                  </b-card-title>
                  <p v-html="nl2br(mandat.note_cloture.value)"></p>
                  <b-button
                    size="sm"
                    icon
                    :href="clotureMandatPdfPath()"
                    target="_blank"
                  >
                    <b-icon-printer-fill></b-icon-printer-fill>
                  </b-button>
                  <b-button
                    size="sm"
                    icon
                    class="ml-3"
                    @click="$bvModal.show('email-nc')"
                  >
                    <b-icon-envelope-fill></b-icon-envelope-fill>
                  </b-button>
                </b-card>
              </b-col>
              <b-modal
                title="Envoyer le document par mail"
                id="email-nc"
                size="lg"
                title-class="text-center"
                hide-footer
              >
                <NoteClotureMail
                  @close="$bvModal.hide('email-nc')"
                  object="mandat_nc"
                  :mandat_id="mandat.ID.value"
                >
                </NoteClotureMail>
              </b-modal>
            </b-row>
            <b-row>
              <b-col lg="4" sm="12" class="mb-3">
                <b-card class="shadow bg-light">
                  <b-card-title title-tag="h6" class="mb-0">
                    <div class="d-flex justify-content-between">
                      <div>
                        Créancier :
                        <b-link
                          v-if="$store.getters.isAdmin"
                          :to="{
                            name: 'creditorView',
                            params: { id: mandat.creancierID.value },
                          }"
                          >{{ mandat.creancier.nom_soc.value }}</b-link
                        >
                        <span v-else>{{ mandat.creancier.nom_soc.value }}</span>
                        <span v-if="mandat.realCreancier_telephone">
                          ({{ mandat.realCreancier_telephone.value }})</span
                        >
                      </div>
                    </div>
                  </b-card-title>
                  <b-card-body class="p-1">
                    <b-row class="my-0">
                      <mh-input
                        mh-class="col-12"
                        label="Effectif"
                        field="realCreancier_nom_soc"
                        :readonly="!edit"
                        :table="mandat"
                        @change="save_debounce('realCreancier_nom_soc')"
                      ></mh-input>
                      <mh-input
                        mh-class="col-12"
                        label="Mail"
                        field="email"
                        readonly
                        :table="mandat.creancier"
                      >
                      </mh-input>
                      <mh-input
                        mh-class="col-6"
                        label="Mandats"
                        field="nombreMandats"
                        readonly
                        :table="mandat.creancier"
                      ></mh-input>
                      <mh-input
                        mh-class="col-6"
                        field="realCreancier_telephone"
                        label="Tél."
                        :readonly="!edit"
                        :table="mandat"
                        @change="save_debounce('realCreancier_telephone')"
                      ></mh-input>
                      <mh-input
                        mh-class="col-12"
                        label="Ref. Créancier"
                        field="ref_creancier"
                        :readonly="!edit"
                        :table="mandat"
                        @change="save_debounce('ref_creancier')"
                      ></mh-input>
                      <mh-input
                        mh-class="col-12"
                        label="Ref. Avocat"
                        field="ref_avocat"
                        :readonly="!edit"
                        :table="mandat"
                        @change="save_debounce('ref_avocat')"
                      ></mh-input>
                      <mh-input
                        mh-class="col-12"
                        label="Ref. Huissier"
                        field="ref_huissier"
                        :readonly="!edit"
                        :table="mandat"
                        @change="save_debounce('ref_huissier')"
                      ></mh-input>
                    </b-row>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col md="12" lg="4" class="mb-3">
                <b-card class="shadow bg-light">
                  <b-card-title title-tag="h6" class="mb-0">
                    <div class="d-flex justify-content-between">
                      <div>
                        Débiteur :
                        <b-link
                          :to="{
                            name: 'debtorView',
                            params: {
                              id: mandat.debiteurID.value,
                              edit: true,
                            },
                          }"
                          >{{ mandat.debiteur.nom_complet.value }}</b-link
                        >
                        <span v-if="mandat.debiteur.gsm.value">
                          ({{ mandat.debiteur.gsm.value }})</span
                        >
                        <b-badge
                          variant="danger"
                          class="ml-2"
                          v-if="mandat.debiteur.totalMandatOpenClosed.value > 0"
                          >{{
                            mandat.debiteur.totalMandatOpenClosed.value
                          }}</b-badge
                        >
                      </div>
                    </div>
                  </b-card-title>
                  <b-card-body class="p-1">
                    <b-row>
                      <mh-input
                        mh-class="col-12"
                        field="gsm"
                        :readonly="!edit"
                        isMobileNumber
                        :table="mandat.debiteur"
                        @change="save(false, true)"
                        labelColsLg="2"
                      ></mh-input>
                      <b-col lg="12" v-if="mandat.sms_valide" class="my-1">
                        <div
                          class="
                            small
                            border-primary
                            bg-success
                            rounded
                            text-white
                            py-1
                            px-2
                          "
                        >
                          Numéro de GSM valide pour envoi des SMS
                        </div>
                      </b-col>
                      <b-col lg="12" class="my-1" v-else>
                        <div
                          class="
                            small
                            border-primary
                            bg-danger
                            rounded
                            text-white
                            py-1
                            px-2
                          "
                        >
                          Numéro de GSM non valide pour envoi des SMS
                        </div>
                      </b-col>
                      <mh-input
                        mh-class="col-12"
                        label="Mail"
                        field="email"
                        :readonly="!edit"
                        :table="mandat.debiteur"
                        @change="save_debounce('debiteur')"
                        labelColsLg="2"
                      ></mh-input>

                      <mh-input
                        mh-class="col-6"
                        label="Mandats"
                        field="totalMandatOpenClosed"
                        readonly
                        :table="mandat.debiteur"
                      ></mh-input>
                      <mh-input
                        mh-class="col-6"
                        label="ID"
                        field="ID"
                        readonly
                        :table="mandat.debiteur"
                      ></mh-input>
                      <mh-input
                        mh-class="col-12"
                        field="lastCourrierDate"
                        readonly
                        :table="mandat.debiteur"
                        labelColsLg="6"
                      ></mh-input>
                      <mh-input
                        mh-class="col-12"
                        field="lastNegoDate"
                        :table="mandat"
                        @change="save_debounce('lastNegoDate')"
                        labelColsLg="6"
                      >
                      </mh-input>
                    </b-row>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col md="12" lg="4" class="mb-3">
                <b-card class="shadow bg-light">
                  <b-card-title title-tag="h6" class="mb-0">
                    <div class="d-flex justify-content-between">
                      <div>Adresse des courriers débiteur pour ce mandat</div>
                    </div>
                  </b-card-title>
                  <b-card-body class="p-1">
                    <b-row>
                      <mh-input
                        mh-class="col-8"
                        field="courrier_nom_soc"
                        :readonly="!edit"
                        :table="mandat"
                        @change="save_debounce('courrier_nom_soc')"
                      ></mh-input>
                      <mh-input
                        mh-class="col-4"
                        field="courrier_titre"
                        :readonly="!edit"
                        :table="mandat"
                        @change="save_debounce('courrier_titre')"
                      ></mh-input>
                      <mh-input
                        mh-class="col-6"
                        field="courrier_prenom"
                        :readonly="!edit"
                        :table="mandat"
                        @change="save_debounce('courrier_prenom')"
                      ></mh-input>
                      <mh-input
                        mh-class="col-6"
                        field="courrier_nom"
                        :readonly="!edit"
                        :table="mandat"
                        @change="save_debounce('courrier_nom')"
                      ></mh-input>
                      <mh-input
                        mh-class="col-12"
                        field="courrier_rue1"
                        :readonly="!edit"
                        :table="mandat"
                        debounce="400"
                        :autocomplete="{ field: 'google.places' }"
                        @enter="suggestAddress($event)"
                        @change="save_debounce('courrier_rue1')"
                      >
                      </mh-input>
                      <mh-input
                        mh-class="col-12"
                        field="courrier_rue2"
                        :readonly="!edit"
                        :table="mandat"
                        @change="save_debounce('courrier_rue2')"
                      ></mh-input>
                      <mh-input
                        mh-class="col-6"
                        field="courrier_codepostal"
                        :readonly="!edit"
                        :table="mandat"
                        @change="save_debounce('courrier_codepostal')"
                      ></mh-input>
                      <mh-input
                        mh-class="col-6"
                        field="courrier_localite"
                        :readonly="!edit"
                        :table="mandat"
                        @change="save_debounce('courrier_localite')"
                      ></mh-input>
                      <mh-input
                        mh-class="offset-lg-6 col-6"
                        field="courrier_pays"
                        :readonly="!edit"
                        :table="mandat"
                        @change="save_debounce('courrier_pays')"
                      ></mh-input>
                      <b-col lg="12" v-if="notSyncAdress">
                        <b-button @click="syncAddress()">Synchroniser</b-button>
                      </b-col>
                    </b-row>
                  </b-card-body>
                </b-card>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12" lg="6">
                <b-card class="mb-2 shadow" no-body>
                  <b-tabs v-model="note_tabindex" card content-class="mt-2">
                    <b-tab title="Notes" active>
                      <b-button
                        size="sm"
                        icon
                        title="Ajouter une note"
                        @click="note_ajouter('public', ['prive', 'public'])"
                        class="mb-3"
                      >
                        <b-icon-plus-circle-fill></b-icon-plus-circle-fill>
                      </b-button>
                      <b-button
                        size="sm"
                        icon
                        title="Indique les notes comme lues"
                        variant="success"
                        v-if="
                          numberOfNotesNoteRead > 0 && $store.getters.isAdmin
                        "
                        @click="note_lues()"
                        class="mb-3 ml-3"
                      >
                        <b-icon-check></b-icon-check>
                      </b-button>
                      <b-table
                        style="
                          display: block;
                          max-height: 503px;
                          overflow: auto;
                        "
                        v-if="mandat.notes.length > 0"
                        id="notesTable"
                        responsive
                        small
                        fixed
                        striped
                        hover
                        :fields="notesFields"
                        :items="filterNotes()"
                      >
                        <template v-slot:cell(read)="data">
                          <div v-html="toBadge(data.item.read)"></div>
                        </template>
                        <template v-slot:cell(when)="data">{{
                          toDate(data.item.when)
                        }}</template>
                        <template v-slot:cell(initiale)="data">{{
                          data.item.initiale
                        }}</template>
                        <template v-slot:cell(type)="data">
                          <b-icon-lock-fill
                            v-if="data.item.type == 'prive'"
                            variant="danger"
                          ></b-icon-lock-fill>
                          <b-icon-unlock-fill
                            v-else-if="data.item.type == 'public'"
                            variant="success"
                          ></b-icon-unlock-fill>
                        </template>
                        <template v-slot:cell(content)="data">
                          <div
                            class="note-content"
                            v-html="data.item.content"
                          ></div>
                          <template
                            v-if="
                              data.item.actions.length > 0 &&
                              $store.getters.isAdmin
                            "
                          >
                            <span
                              size="sm"
                              v-for="(action, action_index) in data.item
                                .actions"
                              :key="action_index"
                            >
                              <b-button
                                class="m-2"
                                size="sm"
                                :to="{
                                  name: action.name,
                                  params: action.params,
                                }"
                                v-if="action.name"
                              >
                                {{ action.label }}
                              </b-button>
                              <b-button
                                class="m-2"
                                size="sm"
                                v-if="
                                  action.function &&
                                  action.function == 'activeDom' &&
                                  mandat.domiciliation.value == 'non'
                                "
                                @click="activeDom()"
                              >
                                {{ action.label }}
                              </b-button>
                              <b-button
                                @click="dyn_update(action)"
                                class="m-2"
                                size="sm"
                                v-if="action.api"
                                >{{ action.label }}</b-button
                              >
                            </span>
                          </template>
                        </template>
                        <template v-slot:cell(actions)="data">
                          <b-button
                            v-if="$store.getters.isAdmin"
                            size="sm"
                            variant="secondary"
                            icon
                            class="btn-xs"
                            @click="
                              note_modifier(data.item.ID, ['prive', 'public'])
                            "
                          >
                            <b-icon-pen-fill></b-icon-pen-fill>
                          </b-button>
                          <b-button
                            v-if="$store.getters.isAdmin"
                            class="ml-3 btn-xs"
                            icon
                            size="sm"
                            variant="danger"
                            @click="note_supprimer(data.item.ID)"
                          >
                            <b-icon-x-circle-fill></b-icon-x-circle-fill>
                          </b-button>
                        </template>
                      </b-table>
                      <b-card-body v-else>
                        <b-alert show>Pas de notes</b-alert>
                      </b-card-body>
                    </b-tab>
                    <b-tab lazy title="Paiements en suspens">
                      <template #title>
                        Paiements en suspens
                        <span
                          v-if="
                            mandat.notes.filter(
                              (x) => x.type == 'paiements_suspens'
                            ).length > 0
                          "
                          >({{
                            mandat.notes.filter(
                              (x) => x.type == "paiements_suspens"
                            ).length
                          }})</span
                        >
                      </template>

                      <b-button
                        size="sm"
                        @click="note_ajouter('paiements_suspens')"
                      >
                        <b-icon-plus-circle-fill></b-icon-plus-circle-fill>
                      </b-button>
                      <b-table
                        v-if="
                          mandat.notes.filter(
                            (x) => x.type == 'paiements_suspens'
                          ).length > 0
                        "
                        responsive
                        id="notesTable"
                        striped
                        small
                        hover
                        :fields="notesFields"
                        :items="
                          mandat.notes.filter(
                            (x) => x.type == 'paiements_suspens'
                          )
                        "
                      >
                        <template v-slot:cell(read)="data">
                          <div v-html="toBadge(data.item.read)"></div>
                        </template>
                        <template v-slot:cell(when)="data">{{
                          toDate(data.item.when)
                        }}</template>
                        <template v-slot:cell(initiale)="data">{{
                          data.item.initiale
                        }}</template>
                        <template v-slot:cell(type)="data">
                          <b-icon-lock-fill
                            v-if="data.item.type == 'prive'"
                            variant="danger"
                          ></b-icon-lock-fill>
                          <b-icon-unlock-fill
                            v-else
                            variant="success"
                          ></b-icon-unlock-fill>
                        </template>
                        <template v-slot:cell(content)="data">
                          <div v-html="data.item.content"></div>
                        </template>
                        <template v-slot:cell(actions)="data">
                          <b-button
                            v-if="$store.getters.isAdmin"
                            size="sm"
                            variant="secondary"
                            @click="note_modifier(data.item.ID)"
                            class="btn-xs"
                          >
                            <b-icon-pen-fill></b-icon-pen-fill>
                          </b-button>
                          <b-button
                            v-if="$store.getters.isAdmin"
                            size="sm"
                            variant="danger"
                            class="btn-xs ml-2"
                            @click="note_supprimer(data.item.ID)"
                          >
                            <b-icon-x-circle-fill></b-icon-x-circle-fill>
                          </b-button>
                        </template>
                      </b-table>
                      <b-card-body v-else>
                        <b-alert show>Pas de notes</b-alert>
                      </b-card-body>
                    </b-tab>
                    <b-tab lazy>
                      <template #title>
                        Domiciliation
                        <span
                          v-if="
                            mandat.notes.filter(
                              (x) => x.type == 'domiciliation'
                            ).length > 0
                          "
                          >({{
                            mandat.notes.filter(
                              (x) => x.type == "domiciliation"
                            ).length
                          }})</span
                        >
                        <b-icon-check-circle-fill
                          class="ml-2"
                          v-if="mandat.domiciliation.value == 'oui'"
                          variant="success"
                        ></b-icon-check-circle-fill>
                      </template>

                      <b-button
                        v-if="$store.getters.isAdmin"
                        size="sm"
                        icon
                        @click="note_ajouter('domiciliation')"
                      >
                        <b-icon-plus-circle-fill></b-icon-plus-circle-fill>
                      </b-button>
                      <b-button
                        size="sm"
                        class="ml-2"
                        v-if="
                          mandat.domiciliation.value == 'oui' &&
                          $store.getters.isAdmin
                        "
                        @click="deactiveDom()"
                        variant="danger"
                        >Désactiver domiciliation</b-button
                      >
                      <b-button
                        v-else-if="
                          mandat.domiciliation.value == 'non' &&
                          $store.getters.isAdmin
                        "
                        size="sm"
                        class="ml-2"
                        @click="activeDom()"
                        variant="success"
                        >Activer domiciliation
                      </b-button>
                      <b-table
                        v-if="
                          mandat.notes.filter((x) => x.type == 'domiciliation')
                            .length > 0
                        "
                        id="notesTable"
                        responsive
                        small
                        striped
                        hover
                        :fields="notesFields"
                        :items="
                          mandat.notes.filter((x) => x.type == 'domiciliation')
                        "
                      >
                        <template v-slot:cell(read)="data">
                          <div v-html="toBadge(data.item.read)"></div>
                        </template>
                        <template v-slot:cell(when)="data">{{
                          toDate(data.item.when)
                        }}</template>
                        <template v-slot:cell(initiale)="data">{{
                          data.item.initiale
                        }}</template>
                        <template v-slot:cell(type)="data">
                          <b-icon-lock-fill
                            v-if="data.item.type == 'prive'"
                            variant="danger"
                          ></b-icon-lock-fill>
                          <b-icon-unlock-fill
                            v-else
                            variant="success"
                          ></b-icon-unlock-fill>
                        </template>
                        <template v-slot:cell(content)="data">
                          <div v-html="data.item.content"></div>
                        </template>
                        <template v-slot:cell(actions)="data">
                          <b-button
                            v-if="$store.getters.isAdmin"
                            size="sm"
                            variant="secondary"
                            @click="
                              note_modifier(data.item.ID, ['domiciliation'])
                            "
                          >
                            <b-icon-pen-fill></b-icon-pen-fill>
                          </b-button>
                          <b-button
                            v-if="$store.getters.isAdmin"
                            class="ml-3"
                            size="sm"
                            variant="danger"
                            @click="note_supprimer(data.item.ID)"
                          >
                            <b-icon-x-circle-fill></b-icon-x-circle-fill>
                          </b-button>
                        </template>
                      </b-table>
                      <b-card-body v-else>
                        <b-alert show>Pas de notes</b-alert>
                      </b-card-body>
                    </b-tab>

                    <b-tab lazy :active="tab == 'courriers'" title="Courriers">
                      <template #title>
                        Courriers
                        <span v-if="mandat.debiteur_courriers.length > 0"
                          >({{ mandat.debiteur_courriers.length }})</span
                        >
                      </template>

                      <template v-for="(courrier, i) in mandat.courriers_type">
                        <b-button
                          v-if="courrier.shortcut == 'yes'"
                          :key="i"
                          class="mr-3 mb-2"
                          size="sm"
                          @click="
                            (selected_courrier_typeID = courrier.ID) &&
                              $bvModal.show('modal-courrier')
                          "
                          >{{ courrier.shortcut_label }}</b-button
                        >
                      </template>
                      <b-dropdown
                        id="dropdown-1"
                        size="sm"
                        text="Autre courrier"
                        class="mr-3 mb-2"
                        no-flip
                      >
                        <template
                          v-for="(courrier, i) in mandat.courriers_type"
                        >
                          <b-dropdown-item
                            v-if="courrier.shortcut == 'no'"
                            @click="
                              (selected_courrier_typeID = courrier.ID) &&
                                $bvModal.show('modal-courrier')
                            "
                            :key="i"
                            >{{ courrier.nom }}</b-dropdown-item
                          >
                        </template>
                      </b-dropdown>
                      <b-table
                        v-if="mandat.debiteur_courriers.length > 0"
                        hover
                        responsive
                        small
                        :fields="mailsFields"
                        :items="mandat.debiteur_courriers"
                      >
                        <template v-slot:cell(date)="data">{{
                          toDate(data.item.date)
                        }}</template>

                        <template #row-details="data">
                          <b-card>
                            <div v-html="nl2br(data.item.content)"></div>
                          </b-card>
                        </template>
                        <template v-slot:cell(actions)="data">
                          <b-button
                            class="mr-2 btn-xs"
                            size="sm"
                            @click="data.toggleDetails"
                          >
                            <b-icon-eye-fill
                              v-if="!data.detailsShowing"
                            ></b-icon-eye-fill>
                            <b-icon-eye-slash-fill
                              v-else
                            ></b-icon-eye-slash-fill>
                          </b-button>
                          <b-button
                            class="mr-2 btn-xs"
                            size="sm"
                            @click="email_courrier(data.item.ID)"
                          >
                            <b-icon-envelope-fill></b-icon-envelope-fill>
                          </b-button>
                          <b-button
                            size="sm"
                            class="mr-3 btn-xs"
                            target="_blank"
                            :href="courrier_pdf(data.item.ID)"
                          >
                            <b-icon-printer-fill></b-icon-printer-fill>
                          </b-button>
                          <b-button
                            v-if="$store.getters.isAdmin"
                            @click="delete_courrier(data.item.ID)"
                            size="sm"
                            class="mr-3 btn-xs"
                            variant="danger"
                          >
                            <b-icon-x-circle-fill></b-icon-x-circle-fill>
                          </b-button>
                        </template>
                      </b-table>
                      <b-alert v-else show class="mt-3"
                        >Pas encore de courrier pour ce débiteur</b-alert
                      >

                      <b-modal
                        id="modal-courrier"
                        size="xxl"
                        title-class="text-center"
                        hide-footer
                        hide-header
                      >
                        <Courrier
                          @close="closeCourrierModal()"
                          :mandat="mandat"
                          :courrier_typeID="selected_courrier_typeID"
                        ></Courrier>
                      </b-modal>
                      <b-modal
                        title="Envoyer le courrier par mail"
                        id="email-courrier"
                        size="lg"
                        title-class="text-center"
                        hide-footer
                      >
                        <CourrierMail
                          v-if="current_courrier !== null"
                          @close="$bvModal.hide('email-courrier')"
                          :courrier_id="current_courrier"
                        ></CourrierMail>
                      </b-modal>
                    </b-tab>
                    <b-tab lazy :active="tab == 'documents'" title="Documents">
                      <template #title>
                        Documents
                        <span v-if="mandat.documents.length > 0"
                          >({{ mandat.documents.length }})</span
                        >
                      </template>

                      <Documents
                        object="mandat"
                        :id="mandat.ID.value"
                      ></Documents>
                      <b-modal
                        id="modal_md"
                        size="xxl"
                        title="Mise en demeure pour huissier de justice"
                        hide-footer
                      >
                        <MDMail
                          @close="confirm_md"
                          object="mandat_MD"
                          :mandat_id="mandat.ID.value"
                        >
                        </MDMail>
                      </b-modal>
                      <b-modal
                        id="modal-accuse"
                        size="xxl"
                        title="Accusé de réception"
                        hide-footer
                      >
                        <AccuseMail
                          @close="$bvModal.hide('modal-accuse')"
                          object="mandat_ack"
                          :mandat_id="mandat.ID.value"
                          :ack_id="mandat.ackID.value"
                        ></AccuseMail>
                      </b-modal>
                      <b-modal
                        id="modal-assignation"
                        size="xxl"
                        title="Assignation en justice"
                        hide-footer
                      >
                        <AssignationMail
                          @close="$bvModal.hide('modal-assignation')"
                          object="mandat_assignation"
                          :mandat_id="mandat.ID.value"
                        ></AssignationMail>
                      </b-modal>
                    </b-tab>
                    <b-tab lazy :active="tab == 'sms'" title="SMS">
                      <template #title>
                        SMS
                        <span v-if="mandat.debiteur_sms.length > 0"
                          >({{ mandat.debiteur_sms.length }})</span
                        >
                      </template>
                      <b-table
                        v-if="mandat.debiteur_sms.length > 0"
                        hover
                        responsive
                        small
                        :fields="smsFields"
                        :items="mandat.debiteur_sms"
                      >
                        <template v-slot:cell(date_sent)="data">{{
                          toDate(data.item.date_sent)
                        }}</template>
                      </b-table>
                      <b-alert v-else show>Pas de SMS energistrés</b-alert>
                    </b-tab>
                  </b-tabs>
                </b-card>
              </b-col>
              <b-col lg="6">
                <b-card class="mb-2 shadow bg-light">
                  <b-row>
                    <mh-input
                      mh-class="col-4"
                      label="Statut"
                      field="status"
                      :table="mandat"
                      @change="changeStatus()"
                    >
                    </mh-input>
                    <mh-input
                      mh-class="col-4"
                      label="Priorité"
                      field="priorite"
                      :readonly="!edit"
                      :table="mandat"
                      @change="save_debounce('priorite')"
                    ></mh-input>
                    <mh-input
                      :mh-class="$store.getters.isAdmin ? 'col-3' : 'col-4'"
                      label="Négo"
                      field="negotiateurID"
                      :readonly="!edit"
                      :table="mandat"
                      @change="save_debounce('negotiateurID',false, false, true)"
                    ></mh-input>
                    <b-col
                      lg="1"
                      class="d-flex align-self-center justify-content-around"
                      v-if="$store.getters.isAdmin"
                    >
                      <b-button
                        @click="autoSetNego(false)"
                        size="sm"
                        variant="success"
                        title="Attribuer le négociateur automatiquement"
                        class="btn-xs"
                        ><i class="fad fa-magic"></i>
                      </b-button>
                      <b-button
                        @click="alertNego"
                        size="sm"
                        class="btn-xs"
                        variant="danger"
                        title="Alerter le négociateur"
                      >
                        <b-icon-alarm></b-icon-alarm>
                      </b-button>
                    </b-col>
                    <mh-input
                      mh-class="col-4"
                      field="popUpAgenda"
                      :readonly="!edit"
                      :table="mandat"
                      @change="changeAgenda()"
                    ></mh-input>
                    <mh-input
                      mh-class="col-4"
                      label="SMS"
                      field="sms"
                      :readonly="!edit"
                      :table="mandat"
                      @change="save_debounce('sms')"
                    ></mh-input>
                    <mh-input
                      mh-class="col-4"
                      label="RA"
                      field="rechercheAdresse"
                      :readonly="!edit"
                      :table="mandat.debiteur"
                      @change="save_debounce('debiteur')"
                    ></mh-input>
                    <mh-input
                      mh-class="col-4"
                      label="Particulier"
                      field="calcul_particulier"
                      :readonly="!edit"
                      :table="mandat"
                      @change="save_debounce('calcul_particulier')"
                    ></mh-input>
                    <mh-input
                      mh-class="col-4"
                      label="À vérifier"
                      field="toCheck"
                      :readonly="!edit"
                      :table="mandat"
                      @change="save_debounce('toCheck')"
                    ></mh-input>
                    <mh-input
                      mh-class="col-4"
                      label="Export MD"
                      field="md_tag"
                      :readonly="!edit"
                      :table="mandat"
                      @change="save_debounce('md_tag')"
                    ></mh-input>
                    <b-col lg="4">
                      <b-row>
                        <mh-input
                          mh-class="col-12"
                          label="Création"
                          field="date_creation"
                          readonly
                          :table="mandat"
                        >
                        </mh-input>
                        <mh-input
                          mh-class="col-12"
                          label="Ouverture"
                          field="date_ouverture"
                          readonly
                          :table="mandat"
                        >
                        </mh-input>
                        <mh-input
                          mh-class="col-12"
                          label="Clôture"
                          field="date_cloture"
                          readonly
                          :table="mandat"
                        >
                        </mh-input>
                      </b-row>
                    </b-col>
                    <b-col lg="8">
                      <b-row>
                        <mh-input
                          mh-class="col-12"
                          label="Position"
                          field="debiteur_state_machineID"
                          readonly
                          :table="mandat"
                        ></mh-input>
                        <mh-input
                          mh-class="col-6"
                          label="Changement"
                          field="dsm_switch_date"
                          readonly
                          :table="mandat"
                        >
                        </mh-input>
                        <mh-input
                          mh-class="col-6"
                          label="Rap. Avocat"
                          field="lastAvocatRappelDate"
                          readonly
                          :table="mandat"
                        ></mh-input>
                        <mh-input
                          label="Mode"
                          mh-class="col-6"
                          field="modeID"
                          :readonly="!edit"
                          :table="mandat"
                          @change="save_debounce('modeID')"
                        ></mh-input>
                        <mh-input
                          mh-class="col-6"
                          field="toVisit"
                          :readonly="!edit"
                          :table="mandat"
                          @change="save_debounce('toVisit')"
                          labelColsLg="4"
                        ></mh-input>
                      </b-row>
                    </b-col>
                  </b-row>
                  <div class="d-flex justify-content-between mt-3">
                    <b-button
                      target="_blank"
                      size="sm"
                      :href="negopdf"
                      :disabled="mandat.status.value == 'closed'"
                      :icon="breakpoint == 'md' || breakpoint == 'xs'"
                    >
                      <b-icon-file-earmark-person
                        class="mr-2"
                      ></b-icon-file-earmark-person>
                      <span v-if="breakpoint == 'lg'">Document négo</span>
                    </b-button>
                    <b-button
                      size="sm"
                      class="ml-3"
                      target="_blank"
                      :href="avispdf"
                      :icon="breakpoint == 'md' || breakpoint == 'xs'"
                      :disabled="mandat.status.value == 'closed'"
                    >
                      <b-icon-box-arrow-in-right
                        class="mr-2"
                      ></b-icon-box-arrow-in-right>
                      <span v-if="breakpoint == 'lg'">Avis de passage</span>
                    </b-button>

                    <b-button
                      size="sm"
                      v-if="$store.getters.isAdmin"
                      @click="$bvModal.show('modal-agenda')"
                      class="ml-3"
                      :disabled="mandat.status.value == 'closed'"
                    >
                      <b-icon-calendar-check
                        class="mr-2"
                      ></b-icon-calendar-check>
                      Agenda
                    </b-button>
                    <b-button
                      size="sm"
                      class="ml-3"
                      :to="{
                        name: 'settlements',
                        params: { id: mandat.ID.value },
                      }"
                    >
                      <b-icon-clock-history class="mr-2"></b-icon-clock-history>
                      Historique arr.
                    </b-button>
                    <b-button
                      size="sm"
                      v-if="mandat.arrangementID.value != 0"
                      variant="success"
                      class="ml-3"
                      :to="{
                        name: 'settlement',
                        params: { id: mandat.arrangementID.value },
                      }"
                      >Arrangement en cours ({{
                        mandat.arrangementID.value
                      }})</b-button
                    >
                    <b-button
                      v-else-if="
                        $store.getters.isAdmin &&
                        mandat.arrangementID.value == 0
                      "
                      size="sm"
                      :to="{
                        name: 'newSettlement',
                        params: { id: mandat.ID.value },
                      }"
                      class="ml-3"
                      variant="info"
                    >
                      <b-icon-patch-check class="mr-2"></b-icon-patch-check
                      >Marquer un arrangement
                    </b-button>
                    <b-button
                      size="sm"
                      variant="danger"
                      class="ml-3"
                      @click="open_rappel_avocat()"
                      v-if="mandat.debiteur_state_machineID.value == 20"
                      >Rappel avocat</b-button
                    >
                  </div>
                </b-card>
              </b-col>
            </b-row>

            <b-row>
              <b-col lg="12" class="mb-2">
                <warrant-invoices
                  :key="render + 1"
                  :id="mandat.ID.value"
                  :createInvoice="mandat.arrangementID.value == 0"
                  @change="load"
                  ref="warrant_invoices"
                >
                </warrant-invoices>
              </b-col>
              <b-col lg="8">
                <warrant-indemnities
                  :key="render + 3"
                  @change="load"
                  :id="mandat.ID.value"
                  :arrangement="mandat.arrangementID.value"
                ></warrant-indemnities>
              </b-col>
              <b-col lg="4">
                <b-card class="mb-3 bg-light shadow">
                  <b-card-title title-tag="h6"
                    >Valeurs des indemnités</b-card-title
                  >
                  <b-button
                    v-if="$store.getters.isAdmin"
                    @click="$bvModal.show('editIndemnities')"
                    size="sm"
                    title="Modifier"
                    class="mr-3 mb-3"
                  >
                    <b-icon-pencil-fill></b-icon-pencil-fill>
                  </b-button>
                  <b-table
                    small
                    striped
                    hover
                    :items="IndemnitiesValues"
                    :tbody-tr-class="indemnitiesClass"
                  >
                  </b-table>
                  <b-modal
                    size="lg"
                    id="editIndemnities"
                    title="Modifier les indemnités"
                    @close="$bvModal.hide('editIndemnities')"
                    hide-footer
                  >
                    <b-row>
                      <mh-input
                        mhClass="col-4"
                        field="negotiateurID"
                        :table="temp_mandat"
                      >
                      </mh-input>
                      <b-col lg="2" class="align-self-end">
                        <b-button @click="autoSetNego" size="sm"
                          >Automatique</b-button
                        >
                      </b-col>
                      <mh-input
                        mhClass="col-6"
                        field="alertNego"
                        :table="temp_mandat"
                      ></mh-input>

                      <mh-input
                        mhClass="col-6"
                        field="commission"
                        :table="temp_mandat"
                        append="%"
                        min="1"
                        @change="testCom"
                      ></mh-input>
                      <mh-input
                        mhClass="col-6"
                        field="commission_nego"
                        :table="temp_mandat"
                        append="%"
                        @change="testCom"
                      ></mh-input>
                      <mh-input
                        mhClass="col-6"
                        field="interet"
                        :table="temp_mandat"
                      ></mh-input>
                      <mh-input
                        mhClass="col-6"
                        field="interet_taux"
                        :table="temp_mandat"
                        @change="testCom"
                        append="%"
                      >
                      </mh-input>
                      <mh-input
                        mhClass="col-6"
                        field="frais_dossier"
                        :table="temp_mandat"
                        append="€"
                      ></mh-input>
                      <mh-input
                        mhClass="col-6"
                        field="indemnite_minimum"
                        :table="temp_mandat"
                        append="€"
                      ></mh-input>
                      <mh-input
                        mhClass="col-6"
                        field="clause_penale_taux"
                        :table="temp_mandat"
                        @change="testCom"
                        append="%"
                      >
                      </mh-input>
                    </b-row>
                    <hr />
                    <div class="d-flex justify-content-end">
                      <b-button
                        @click="$bvModal.hide('editIndemnities')"
                        variant="danger"
                        >Annuler</b-button
                      >
                      <b-button
                        @click="confirmIndemnities"
                        :disabled="alert_commission"
                        variant="success"
                        class="ml-3"
                      >
                        Confirmer</b-button
                      >
                    </div>
                  </b-modal>
                </b-card>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row v-if="$store.getters.isAdmin">
          <b-col lg="12">
            <bd-table-list
              ref="paymentsRef"
              nobreadcrumb
              nofacets
              nosearch
              title="Paiements"
              bdTable="payement"
              :key="componentKey"
              :actions="payementsActions"
              :query="query"
              :fields="fields"
              :Api="Api"
            >
              <template slot="menu">
                <b-button
                  @click="payement_ajouter()"
                  class="mr-3"
                  title="Ajouter un paiement"
                  size="sm"
                >
                  <b-icon-plus-circle-fill></b-icon-plus-circle-fill>
                </b-button>
              </template>
            </bd-table-list>
          </b-col>
          <b-col lg="12">
            <b-card class="mb-2 shadow bg-light">
              <b-card-title title-tag="h6"> Résumé : </b-card-title>
              <warrant-summary
                :id="mandat.ID.value"
                :key="render"
              ></warrant-summary>

              <b-modal
                id="modal-agenda"
                @ok="agenda"
                @cancel="$bvModal.hide('modal-agenda')"
                cancel-title="Annuler"
              >
                <template #modal-title>
                  Fixer une nouvelle date d'alerte
                </template>
                <b-row>
                  <mh-input
                    mhClass="col-12"
                    label="Ancienne Date"
                    field="popUpAgenda"
                    :table="mandat"
                    readonly
                  >
                  </mh-input>
                  <b-col lg="12" class="mt-3">
                    <b-form-checkbox
                      v-model="pauseMandat"
                      name="checkbox-1"
                      size="sm"
                    >
                      Mettre le mandat en pause
                    </b-form-checkbox>
                  </b-col>

                  <mh-input
                    mhClass="col-12"
                    field="popUpAgenda"
                    :table="temp_mandat"
                  >
                  </mh-input>
                </b-row>
              </b-modal>
            </b-card>
          </b-col>
        </b-row>

        <b-modal
          id="modal-modifier-paiement"
          title="Modifier un paiement"
          hide-footer
        >
          <WarrantPayment
            @change="load"
            @close="$bvModal.hide('modal-modifier-paiement')"
            :payment_id="payment_id"
            :warrant_id="warrant_id"
          ></WarrantPayment>
        </b-modal>
        <b-modal
          id="modal-ajouter-paiement"
          title="Réceptionner un nouveau paiement"
          hide-footer
        >
          <WarrantPayment
            @change="$refs.paymentsRef.submitSearch(false) || render++"
            @close="$bvModal.hide('modal-ajouter-paiement')"
            payment_id="new"
            :warrant_id="warrant_id"
          ></WarrantPayment>
        </b-modal>
        <b-modal
          id="modal-evolution"
          size="xxl"
          title="Évolution"
          hide-footer
          v-if="chartLoaded"
          :key="render + 2"
        >
          <b-col lg="12">
            <highcharts :options="charted" ref="chart"></highcharts>
          </b-col>
          <b-col lg="12">
            <b-table
              id="synopsis"
              striped
              hover
              :items="synopsis"
              responsive
              :fields="synopsisFields"
              @row-hovered="synopsisRowHovered"
            >
              <template v-slot:cell(principal)="data">
                {{ data.item.principal.toFixed(2) }} €
                <span v-if="data.item.deltaPrincipal < 0">
                  <b-icon-arrow-down-right
                    variant="success"
                  ></b-icon-arrow-down-right>
                </span>
                <span v-else>
                  <b-icon-arrow-up-right
                    variant="danger"
                  ></b-icon-arrow-up-right>
                </span>
              </template>
              <template v-slot:cell(solde)="data">
                {{ data.item.solde.toFixed(2) }} €
                <span v-if="synopsis[data.index - 1]">
                  <span v-if="synopsis[data.index - 1].solde > data.item.solde">
                    <b-icon-arrow-down-right
                      variant="success"
                    ></b-icon-arrow-down-right>
                  </span>
                  <span v-else>
                    <b-icon-arrow-up-right
                      variant="danger"
                    ></b-icon-arrow-up-right>
                  </span>
                </span>
                <span v-else>
                  <b-icon-arrow-up-right
                    variant="danger"
                  ></b-icon-arrow-up-right>
                </span>
              </template>
            </b-table>
          </b-col>
        </b-modal>
      </b-col>
    </b-row>

    <b-modal
      id="modal-modifier-note"
      size="lg"
      title="Modifier une note"
      hide-footer
    >
      <WarrantNote
        @change="load()"
        @close="$bvModal.hide('modal-modifier-note')"
        :authorized="notesAuthorized"
        :note_id="note_id"
        :warrant_id="warrant_id"
      ></WarrantNote>
    </b-modal>
    <b-modal
      id="modal-ajouter-note"
      :size="breakpoint"
      title="Ajouter une nouvelle note"
      hide-footer
    >
      <WarrantNote
        @change="load()"
        @close="$bvModal.hide('modal-ajouter-note')"
        note_id="new"
        :authorized="notesAuthorized"
        :type="note_type"
        :warrant_id="warrant_id"
      ></WarrantNote>
    </b-modal>
  </div>
</template>

<script>
import MhInput from "@/components/MhInput.vue";
import warrants from "@/services/warrants";
import negotiators from "@/services/negotiators";
import DateTime from "@/services/DateTime.js";
import WarrantInvoices from "@/components/WarrantInvoices";
import WarrantIndemnities from "@/components/WarrantIndemnities";
import WarrantSummary from "@/components/WarrantSummary";
import Documents from "@/components/Documents";
import NoteClotureMail from "@/components/NoteClotureMail";
import MDMail from "@/components/MDMail";
import RappelAvocatMail from "@/components/RappelAvocatMail";
import RenseignementClient from "@/components/RenseignementClient";
import AssignationMail from "@/components/AssignationMail";
import AccuseMail from "@/components/AccuseMail";
import WarrantPayment from "@/components/WarrantPayment";
import WarrantNote from "@/components/WarrantNote";
import BdTableList from "@/components/BdTableList";
import payments from "@/services/payments.js";
import gestion from "@/services/gestion.js";
import { Chart } from "highcharts-vue";
import CourrierMail from "@/components/CourrierMail";
import Courrier from "@/components/Courrier";
import _ from "lodash";
export default {
  name: "warrant-view",
  components: {
    MhInput,
    WarrantInvoices,
    WarrantIndemnities,
    WarrantSummary,
    WarrantNote,
    WarrantPayment,
    BdTableList,
    highcharts: Chart,
    Documents,
    NoteClotureMail,
    CourrierMail,
    Courrier,
    MDMail,
    AssignationMail,
    AccuseMail,
    RappelAvocatMail,
    RenseignementClient,
  },

  data() {
    return {
      busy: false,
      listener: null,
      tabindex: 0,
      note_tabindex: 0,
      expandInfo: true,
      edit: true,
      notesAuthorized: [],
      numberOfNotesNoteRead: 0,
      render: 0,
      payment_id: null,
      warrant_id: null,
      note_id: null,
      note_type: "prive",
      date_cloture: new Date().toJSON().slice(0, 10),
      pauseMandat: true,
      cloture_body: "",
      stopList: [],
      reasonsSelected: [],
      stop_step: 0,
      charted: {},
      chartLoaded: false,
      componentKey: 0,
      Api: payments,
      renderFields: 0,
      query: [],
      payments: [],
      synopsisFields: [
        {
          key: "period",
          label: "Période",
        },
        {
          key: "display",
          label: "Mouvement(s)",
        },
        {
          key: "principal",
          label: "Principal",
          formatter: (value) => {
            return value.toFixed(2) + " €";
          },
          class: "text-right",
          sortable: true,
        },
        {
          key: "deltaPrincipal",
          label: "Delta",
          formatter: (value) => {
            return value.toFixed(2) + " €";
          },
          class: "text-right",
          sortable: true,
        },
        {
          key: "interet",
          label: "Intérêt",
          formatter: (value) => {
            return value.toFixed(2) + " €";
          },
          class: "text-right",
          sortable: true,
        },
        {
          key: "indemnite",
          label: "Indemnités",
          formatter: (value) => {
            return value.toFixed(2) + " €";
          },
          class: "text-right",
          sortable: true,
        },
        {
          key: "solde",
          label: "Solde",
          formatter: (value) => {
            return value.toFixed(2) + " €";
          },
          class: "text-right",
          sortable: true,
        },
      ],
      fields: [
        {
          key: "type",
          label: "Type",
          sortable: true,
          formatter: (value) => {
            switch (value) {
              case "virement":
                return "Virement";
              case "cheque":
                return "Chèque";
              case "liquide":
                return "Liquide";
              default:
                return "Inconnu";
            }
          },
        },
        {
          key: "factureID",
          label: "N° de facture",
          class: "text-center",
          sortable: true,
          formatter: (value) => {
            if (value) {
              return '<a href="/invoice/view/' + value + '">' + value + "</a>";
            }
            return "<i>En attente de facturation</i>";
          },
        },
        {
          key: "date",
          label: "Date",
          sortable: true,
          class: "text-right",
          formatter: (value) => {
            return this.toDate(value);
          },
        },
        {
          key: "date_encodage",
          label: "Date d'encodage",
          sortable: true,
          class: "text-right",
          formatter: (value) => {
            return this.toDate(value);
          },
        },

        {
          key: "compte_societe",
          label: "Compte société",
          class: "text-center",
          sortable: false,
        },
        {
          key: "compte_debiteur",
          label: "Compte débiteur",
          class: "text-center",
          sortable: false,
        },
        {
          key: "numero_extrait",
          label: "Extrait",
          class: "text-right",
          sortable: false,
        },
        {
          key: "reception",
          label: "Réception",
          class: "text-center",
          sortable: true,
          formatter: (value) => {
            switch (value) {
              case "societe":
                return "Société";
              case "creancier":
                return "Créancier";
              default:
                return "N/A";
            }
          },
        },
        {
          label: "Négocié par",
          key: "negotiateur",
          class: "text-center",
          sortable: true,
        },
        {
          key: "montant",
          label: "Montant",
          formatter: (value) => {
            return value ? value + " €" : "";
          },
          class: "text-right",
          sortable: true,
        },

        {
          key: "actions",
          label: "Actions",
          sortable: false,
          class: "text-center",
          thStyle: "width:100px",
        },
      ],
      payementsActions: [
        {
          label: "Modifier",
          action: this.payement_modifier,
          variant: "success",
          icon: "pencil-square",
          condition: (item) => !item.factureID,
        },
        {
          label: "Supprimer",
          action: this.payement_supprimer,
          icon: "x-circle-fill",
          variant: "danger",
          condition: (item) =>
            !item.factureID && this.$store.getters.isSuperAdmin,
        },
      ],
      current_courrier: null,
      selected_courrier_typeID: null,
      mailsFields: [
        {
          key: "date",
          label: "Date",
          sortable: true,
          thStyle: "width:200px",
        },

        {
          key: "nom",
          label: "Type",
          sortable: true,
        },

        {
          key: "type_envoiID",
          label: "Type",
          sortable: true,
          formatter: (value) => {
            switch (value) {
              case 1:
                return "Recommandé";
              case 2:
                return "Courrier";
              case 3:
                return "Remise en main propre";
              case 4:
                return "Email";
              default:
                return "N/A";
            }
          },
        },
        {
          key: "actions",
          label: "",
          class: "text-right",
          thStyle: "width:300px",
        },
      ],
      loaded: false,
      pdfPath: null,
      mandat: {},
      temp_mandat: {},
      documentsFields: [
        {
          key: "date_encodage",
          label: "Date",
          sortable: true,
        },
        {
          key: "isPrivate",
          label: "Type",
          sortable: false,
          class: "text-center",
        },
        {
          key: "intitule",
          label: "Nom",
          sortable: false,
        },
        {
          key: "note",
          label: "Note",
          sortable: false,
        },
      ],
      smsFields: [
        {
          key: "date_sent",
          label: "Date",
          class: "text-center",
          thStyle: "width:100px",
          sortable: true,
        },
        {
          key: "phone",
          label: "Numéro de tél",
          thStyle: "width:200px",
          class: "text-center",
          sortable: false,
        },
        {
          key: "content",
          label: "Contenu",
        },
      ],
      notesFields: [
        {
          key: "read",
          label: "",
          thStyle: "width:50px",
        },
        {
          key: "when",
          label: "Date",
          sortable: true,
          class: "text-center",
          thStyle: "width:100px",
        },
        {
          key: "type",
          label: "Type",
          sortable: false,
          class: "text-center",
          thStyle: "width:50px",
        },
        {
          key: "initiale",
          label: "Négo",
          sortable: true,
          class: "text-center",
          thStyle: "width:50px",
        },
        {
          key: "content",
          label: "Contenu",
          sortable: false,
          thStyle: { width: "400px" },
        },
        {
          key: "actions",
          label: "Actions",
          sortable: false,
          class: "text-center",
          thStyle: { width: "100px" },
        },
      ],

      items: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Mandats",
          to: { name: "warrants" },
        },
      ],
      alert_commission: null,
      windowWidth: window.innerWidth,
    };
  },
  props: {
    tab: String,
  },
  computed: {
    notSyncAdress() {
      let str1 =
        this.mandat.courrier_nom_soc.value +
        this.mandat.courrier_prenom.value +
        this.mandat.courrier_nom.value +
        this.mandat.courrier_rue1.value +
        this.mandat.courrier_rue2.value +
        this.mandat.courrier_codepostal.value +
        this.mandat.courrier_localite.value +
        this.mandat.courrier_pays.value;
      let str2 =
        this.mandat.debiteur.nom_soc.value +
        this.mandat.debiteur.prenom.value +
        this.mandat.debiteur.nom.value +
        this.mandat.debiteur.rue1.value +
        this.mandat.debiteur.rue2.value +
        this.mandat.debiteur.codepostal.value +
        this.mandat.debiteur.localite.value +
        this.mandat.debiteur.pays.value;
      if (str1 !== str2) {
        return true;
      }
      return false;
    },
    negopdf() {
      return (
        this.$store.getters.url +
        "/warrant/" +
        this.mandat.ID.value +
        "/nego-pdf?token=" +
        encodeURIComponent(localStorage.getItem("vue-token"))
      );
    },
    avispdf() {
      return (
        this.$store.getters.url +
        "/warrant/" +
        this.mandat.ID.value +
        "/avis-pdf?token=" +
        encodeURIComponent(localStorage.getItem("vue-token"))
      );
    },
    IndemnitiesValues() {
      let indemnitesArray = [
        {
          Indemnité: "Commission",
          Valeur: this.mandat.commission.value + " %",
        },
        {
          Indemnité: "Commission Négociateur",
          Valeur: this.mandat.commission_nego.value + " %",
        },
        {
          Indemnité: "Intérêt",
          Valeur: this.mandat.interet.value == "Yes" ? "oui" : "non",
        },
        {
          Indemnité: "Taux d'intérêt",
          Valeur: this.mandat.interet_taux.value + " %",
          Style: (this.mandat.calcul_particulier.value == "yes" && this.mandat.interet_taux.value > this.mandat.taux_interet_particulier.value) ? "striked" : "",
        }
        ];
        if (this.mandat.calcul_particulier.value == "yes" && this.mandat.interet_taux.value > this.mandat.taux_interet_particulier.value){
            indemnitesArray.push({
              Indemnité: "Taux d'intérêt légal particuliers",
              Valeur: this.mandat.taux_interet_particulier.value + " %",
              Style: "italic",
            });
        }
        indemnitesArray.push({
          Indemnité: "Clause pénale",
          Valeur: this.mandat.clause_penale_taux.value + " %",
          Style: (this.mandat.calcul_particulier.value == "yes" && this.mandat.clause_penale.value >= this.mandat.clause_penale_max_particulier.value) ? "striked" : "",
        },
        {
          Indemnité: "Indemnité minimum",
          Valeur: this.mandat.indemnite_minimum.value + " €",
          Style: (this.mandat.calcul_particulier.value == "yes" && this.mandat.clause_penale.value >= this.mandat.clause_penale_max_particulier.value) ? "striked" : "",
        });
        if (this.mandat.calcul_particulier.value == "yes" && this.mandat.clause_penale.value >= this.mandat.clause_penale_max_particulier.value) {
          indemnitesArray.push({
            Indemnité: "Clause pénale légale particuliers",
            Valeur: this.mandat.clause_penale_max_particulier.value + " €",
            Style: "italic"
          });
        }
        indemnitesArray.push(
        {
          Indemnité: "Frais de recouvrement",
          Valeur: this.mandat.frais_dossier.value + " €",
        },
        {
          Indemnité: "Frais de déplacement",
          Valeur: this.mandat.creancier.fraisDeplacement.value + " €",
        });
        return indemnitesArray;
    },
    breakpoint() {
      if (this.windowWidth < 550) return "sm";
      if (this.windowWidth >= 550 && this.windowWidth < 1200) return "md";
      if (this.windowWidth >= 1200) return "lg";
      return null; // This is an unreachable line, simply to keep eslint happy.
    },
    width() {
      return this.windowWidth;
    },
  },
  mounted() {
    this.listener = window.addEventListener("resize", () => {
      this.windowWidth = window.innerWidth;
    });
  },

  destroyed() {
    window.removeEventListener("resize", this.listener);
  },
  created() {
    if (this.$store.getters.isNegotiator) {
      this.edit = false;
    }
    this.load(true);
  },
  watch: {
    $route() {
      // react to route changes...
      this.load(false, true);
    },
  },
  beforeRouteLeave(to, from, next) {
    let a, b;
    a = Object.entries(this.mandat)
      .map((x) => {
        if (x[1] && x[1].value) {
          return x[1].value;
        }
        return null;
      })
      .filter((x) => x !== null)
      .join();
    b = Object.entries(this.temp_mandat)
      .map((x) => {
        if (x[1] && x[1].value) {
          return x[1].value;
        }
        return null;
      })
      .filter((x) => x !== null)
      .join();
    if (a !== b) {
      this.save();
    }
    next();
  },
  methods: {
    indemnitiesClass(item, type){
       if (!item || type !== 'row') return
       if (item.Style) return item.Style
       return
    },
    save_debounce: _.debounce(function (
      field = null,
      recompute = false,
      reload = false,
      alertNego = false,
      syncDebtorAddress = false,
      send_mail_cloture = false
    ) {
      if(field == null) {
        this.save(recompute, reload, alertNego, syncDebtorAddress, send_mail_cloture);
      } else {
        this.save(recompute, reload, alertNego, syncDebtorAddress, send_mail_cloture, field);
      }
      
    },
    500),
    filterNotes() {
      let ret = this.mandat.notes.filter((x) => {
        if (x.type == "prive" || x.type == "public") {
          return true;
        }
        return false;
      });
      return ret;
    },
    syncAddress() {
      this.save(false, true, false, true);
    },
    validateWarrant() {
      this.mandat.dsmID.value = 1;
      this.mandat.toCheck.value = "no";
      this.save(false, true, false, false);
    },
    confirm_md(e) {
      console.log(e, this.mandat.md_tag);
      if (e.confirm) {
        this.mandat.md_tag.value = "yes";
        this.save(false, true, false, false);
      }
      this.$bvModal.hide("modal_md");
    },
    dyn_update(action) {
      gestion.dynamic_update(action.params).then(() => {
        this.$bvToast.toast(action.response, {
          title: `Recuperator`,
          toaster: "b-toaster-top-right",
          variant: "success",
          autoHideDelay: 2000,
          solid: false,
        });
        this.load();
      });
    },
    iconActionMD() {
      this.note_tabindex = 4;
      this.$nextTick(() => {
        this.$bvModal.show("modal_md");
      });
    },
    open_rappel_avocat() {
      this.$bvModal.show("modal-rappel-avocat");
    },
    accuse() {
      this.note_tabindex = 4;
      this.$nextTick(() => {
        this.$bvModal.show("modal-accuse");
      });
    },
    iconActionAssignation() {
      this.note_tabindex = 4;
      this.$nextTick(() => {
        this.$bvModal.show("modal-assignation");
      });
    },
    openEvolution() {
      this.$bvModal.show("modal-evolution");
    },
    addInvoice() {
      this.$refs.warrant_invoices.ajouter();
    },
    suggestAddress(payload) {
      this.mandat.courrier_rue1.value = payload.route || "";
      if (payload.street_number) {
        this.mandat.courrier_rue1.value += ", " + payload.street_number;
      }
      this.mandat.courrier_rue2.value = "";
      this.mandat.courrier_localite.value = payload.city || "";
      this.mandat.courrier_pays.value = payload.country || "";
      this.mandat.courrier_codepostal.value = payload.postal_code || "";
      this.save_debounce();
    },
    alertNego() {
      negotiators.alert_nego(this.mandat.ID.value).then((response) => {
        if (response.data.success) {
          this.$bvToast.toast(response.data.message, {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "success",
            autoHideDelay: 2000,
            solid: false,
          });
        } else {
          this.$bvToast.toast(response.data.message, {
            title: `Recuperator`,
            toaster: "b-toaster-top-right",
            variant: "danger",
            autoHideDelay: 2000,
            solid: false,
          });
        }
      });
    },

    autoSetNego(temp = true) {
      negotiators
        .set_nego(this.mandat.debiteur.codepostal.value)
        .then((response) => {
          if (response.data.negoID) {
            if (temp) {
              this.temp_mandat.negotiateurID.value = response.data.negoID;
            } else {
              this.mandat.negotiateurID.value = response.data.negoID;
              this.save(false, false, true);
            }
          }
        });
    },
    confirmIndemnities() {
      this.mandat.commission = this.temp_mandat.commission;

      this.mandat.commission_nego = this.temp_mandat.commission_nego;
      this.mandat.interet = this.temp_mandat.interet;
      this.mandat.interet_taux = this.temp_mandat.interet_taux;
      this.mandat.frais_dossier = this.temp_mandat.frais_dossier;
      this.mandat.indemnite_minimum = this.temp_mandat.indemnite_minimum;
      // Copier clause_penale_taux vers clause_penale (le champ réel en base)
      this.mandat.clause_penale = this.temp_mandat.clause_penale_taux;
      this.mandat.negotiateurID = this.temp_mandat.negotiateurID;
      this.save(true, false);
      this.$bvModal.hide("editIndemnities");
    },
    testCom() {
      let alert = false;
      if (this.temp_mandat.commission.value <= 0) {
        this.temp_mandat.commission.error =
          "La commission doit être supérieur à 0%";
        alert = true;
      }
      if (
        parseInt(this.temp_mandat.commission_nego.value) >
        this.temp_mandat.commission.value / 2
      ) {
        this.temp_mandat.commission_nego.error =
          "La commission négociateur ne peut pas dépasser la moitié de la commission";
        alert = true;
      }
      if (
        parseInt(this.temp_mandat.interet_taux.value) > 100 ||
        parseInt(this.temp_mandat.interet_taux.value) < 0
      ) {
        this.temp_mandat.interet_taux.error = "Intérêt non valide";
        alert = true;
      }
      this.alert_commission = alert;
      if (!alert) {
        for (let el in this.temp_mandat) {
          if (this.temp_mandat[el].error) {
            this.temp_mandat[el].error = false;
          }
        }
      }
    },
    closeCourrierModal() {
      this.$bvModal.hide("modal-courrier");
      this.load();
    },
    activeDom() {
      this.mandat.domiciliation.value = "oui";
      this.save_debounce('domiciliation');
    },
    deactiveDom() {
      this.mandat.domiciliation.value = "non";
      this.save_debounce('domiciliation');
    },
    courrier_pdf(id) {
      return (
        this.$store.getters.url +
        "/courrier/" +
        id +
        "/pdf?token=" +
        encodeURIComponent(localStorage.getItem("vue-token"))
      );
    },

    email_courrier(id) {
      this.current_courrier = id;
      this.$bvModal.show("email-courrier");
    },
    toBadge(value) {
      if (value == "no") {
        return `<span class="badge badge-danger">Nouveau</span>`;
      }
      return "";
    },
    note_modifier(row, authorized = []) {
      this.warrant_id = this.mandat.ID.value;
      this.note_id = row;
      //this.note_type = payload;
      this.notesAuthorized = authorized.length ? authorized : [];
      this.$bvModal.show("modal-modifier-note");
    },
    note_lues() {
      warrants
        .read_notes({ warrant_id: this.mandat.ID.value })
        .then((response) => {
          if (response.data.success) {
            this.save(false, true);
          }
        });
    },
    cancelWarrant() {
      this.$bvModal
        .msgBoxConfirm("Êtes-vous sûr vouloir annuler ce mandat?", {
          cancelTitle: "Non",
          okTitle: "Oui",
        })
        .then((value) => {
          if (value) {
            warrants
              .cancel_warrant({
                id: this.mandat.ID.value,
              })
              .then((response) => {
                if (response.data.success) {
                  this.load();
                }
              });
          }
        });
    },
    delete_courrier(row) {
      this.$bvModal
        .msgBoxConfirm("Êtes-vous sûr de vouloir supprimer ce courrier?", {
          cancelTitle: "Annuler",
          okTitle: "Supprimer",
        })
        .then((value) => {
          if (value) {
            warrants
              .delete_courrier({
                id: row,
              })
              .then((response) => {
                if (response.data.success) {
                  this.load();
                }
              });
          }
        });
    },
    note_supprimer(row) {
      warrants
        .delete_note({
          warrant_id: this.mandat.ID.value,
          note_id: row,
        })
        .then((response) => {
          if (response.data.success) {
            this.load();
          }
        });
    },
    note_ajouter(payload, authorized = []) {
      this.warrant_id = this.mandat.ID.value;
      this.note_type = payload;
      this.notesAuthorized = authorized.length ? authorized : [this.note_type];
      this.$bvModal.show("modal-ajouter-note");
    },
    payement_modifier(row) {
      this.warrant_id = this.mandat.ID.value;
      this.payment_id = row;
      this.$bvModal.show("modal-modifier-paiement");
    },
    payement_supprimer(row) {
      payments
        .delete_payment({
          warrant_id: this.mandat.ID.value,
          payment_id: row,
        })
        .then((response) => {
          if (response.data.success) {
            this.load();
            this.$refs.paymentsRef.submitSearch(false);
          }
        });
    },
    payement_ajouter() {
      this.warrant_id = this.mandat.ID.value;
      this.$bvModal.show("modal-ajouter-paiement");
    },
    getClotureBody() {
      warrants
        .clotureBody(
          this.mandat.ID.value,
          this.date_cloture,
          this.reasonsSelected
        )
        .then((response) => {
          this.cloture_body = response.data.body;
        });
    },
    load(history = false, tab_init = false) {
      this.busy = true;
      warrants
        .get(this.$route.params.id)
        .then((response) => {
          this.mandat = response.data;
          if (history) {
            this.$store.dispatch("history", {
              object: "mandat",
              objectID: this.mandat.ID.value,
              message: "Consultation du mandat",
              data: {},
            });
          }

          this.$store.commit("set_current_warrant", this.mandat.ID.value);
          this.numberOfNotesNoteRead = this.mandat.notes.filter(
            (x) => x.read == "no"
          ).length;
          if (this.items.length > 2) {
            this.items.pop();
          }
          if (!this.mandat.ID) {
            this.items.push({
              text: "Mandat n° " + this.$route.params.id + " inexistant",

              active: true,
            });
            return;
          }
          this.items.push({
            text:
              "Mandat n° " +
              this.mandat.ID.value +
              " (" +
              this.mandat.creancier.nom_soc.value +
              " vs " +
              this.mandat.debiteur.nom_complet.value +
              ")",
            active: true,
          });
          if (this.mandat.popUpAgenda.value == "0000-00-00") {
            this.mandat.popUpAgenda.value = null;
          }
          if (this.mandat.lastNegoDate.value == "0000-00-00") {
            this.mandat.lastNegoDate.value = null;
          }
          if (this.mandat.date_cloture.value == "0000-00-00") {
            this.mandat.date_cloture.value = null;
          }
          this.loaded = true;
          this.query = [
            {
              sql: "mandatID = " + this.mandat.ID.value,
            },
          ];
          if (
            this.mandat.status.value == "closed" ||
            this.mandat.status.value == "unused"
          ) {
            this.edit = false;
          } else {
            if (!this.$store.getters.isNegotiator) {
              this.edit = true;
            }
          }
          if(tab_init) {
            this.note_tabindex = 0;
          }
          //this.$refs.paymentsRef.submitSearch();
          this.$nextTick(() => {
            this.render++;
            this.componentKey++;
            this.temp_mandat = JSON.parse(JSON.stringify(this.mandat));
          });
          this.busy = false;
        })
        .catch(() => {
          this.loaded = true;
          this.busy = false;
        });
      this.loadChart();
    },
    changeAgenda() {
      if (
        this.mandat.popUpAgenda.value &&
        !this.toDate(this.mandat.popUpAgenda.value)
      ) {
        this.mandat.popUpAgenda.value = null;
        this.save_debounce('popUpAgenda');
        return;
      }
      if (this.mandat.status.value == "open") {
        this.mandat.status.value = "stopped";
      }
      this.save_debounce();
    },
    changeStatus() {
      if (this.mandat.status.value != "suspended") {
        this.mandat.popUpAgenda.value = null;
      }
      this.save_debounce('status');
    },
    save(
      recompute = false,
      reload = false,
      alertNego = false,
      syncDebtorAddress = false,
      send_mail_cloture = false,
      field = null
    ) {
      this.mandat.status.options.forEach((el) => {
        if (el.value == this.mandat.status.value) {
          this.mandat.status.i18n = el.text;
        }
      });
      this.mandat.alertNego.value = "non";
      if (
        this.temp_mandat.negotiateurID.value !==
          this.mandat.negotiateurID.value &&
        alertNego
      ) {
        this.mandat.alertNego.value = "oui";
      }
      this.mandat.debiteur_courrier.courrier_titre.value =
        this.mandat.courrier_titre.value;
      warrants
        .update(
          this.mandat.ID.value,
          this.mandat,
          recompute,
          syncDebtorAddress,
          send_mail_cloture,
          field
        )
        .then((response) => {
          if (response.data.success) {
            this.$bvToast.toast("Mandat mis à jour", {
              title: `Recuperator`,
              toaster: "b-toaster-top-right",
              variant: "success",
              autoHideDelay: 2000,
              solid: false,
            });
            for (let el in this.mandat) {
              if (this.mandat[el] && this.mandat[el].error) {
                this.mandat[el].error = false;
              }
            }
            this.$nextTick(() => {
              this.temp_mandat = JSON.parse(JSON.stringify(this.mandat));
            });

            if (reload) {
              this.load();
            }
          } else if (response.data.fail) {
            for (let el in this.mandat) {
              if (this.mandat[el] && this.mandat[el].error) {
                this.mandat[el].error = false;
              }
            }
            response.data.fail.forEach((element) => {
              this.mandat[element.field].error = element.errors.join(" ; ");
            });
          } else if (response.data.error) {
            this.$bvToast.toast("Erreur : " + response.data.error, {
              title: `Recuperator`,
              toaster: "b-toaster-top-right",
              variant: "danger",
              autoHideDelay: 2000,
              solid: false,
            });
          }
        });
    },
    loadChart() {
      warrants
        .evolution(this.$route.params.id)
        .then((response) => {
          if (!response.data.evolution) return;
          this.charted = {
            chart: {
              type: "area",
            },
            title: {
              text: "Évolution du solde, du principal et des paiements",
            },
            xAxis: {
              categories: Object.keys(response.data.evolution),
              tickmarkPlacement: "on",
              title: {
                enabled: false,
              },
            },
            yAxis: {
              title: {
                text: "Euros (€)",
              },
            },
            tooltip: {
              split: true,
              pointFormat:
                "{series.name}: {point.y} €<br/>Total: {point.stackTotal} €",
            },
            plotOptions: {
              area: {
                stacking: "normal",
                lineColor: "#666666",
                lineWidth: 1,
                marker: {
                  lineWidth: 1,
                  lineColor: "#666666",
                },
              },
            },
            series: [
              {
                name: "Intérêts",
                data: Object.values(response.data.evolution).map(
                  (x) => x.interet
                ),
              },
              {
                name: "Indemnités fixes",
                data: Object.values(response.data.evolution).map(
                  (x) => x.indemnite
                ),
              },
              {
                name: "Principal",
                data: Object.values(response.data.evolution).map(
                  (x) => x.principal
                ),
              },
            ],
          };
          this.synopsis = response.data.synopsis;
          this.chartLoaded = true;
        })
        .catch(() => {
          this.chartLoaded = false;
        });
    },
    agenda() {
      this.mandat.popUpAgenda = this.temp_mandat.popUpAgenda;
      if (this.pauseMandat) {
        this.mandat.status.value = "stopped";
        this.mandat.status.i18n = "suspendu";
      }
      this.save_debounce();
    },
    stop(sendMail = false) {
      this.mandat.status.value = "closed";
      this.mandat.status.i18n = "clôturé";
      this.mandat.note_cloture.value = this.cloture_body;
      this.mandat.date_cloture.value = this.date_cloture;
      this.mandat.popUpAgenda.value = null;
      this.mandat.popUpAgenda.i18n = null;
      this.mandat.dsmID.value = 0;
      this.save(false, true, false, false, sendMail);
    },
    suspend() {
      this.mandat.status.value = "stopped";
      this.mandat.status.i18n = "suspendu";
      this.save_debounce();
    },
    reopen() {
      this.mandat.status.value = "open";
      this.mandat.status.i18n = "ouvert";
      this.mandat.note_suspend.value = "";
      this.mandat.popUpAgenda.value = null;
      this.edit = true;
      this.save_debounce();
    },
    loadstoplist() {
      warrants.get_warrants_stop().then((response) => {
        this.stopList = response.data.map((x) => {
          return { value: x.ID, text: "-".repeat(x.depth * 3) + " " + x.txtFr };
        });
      });
    },
    cloturePdfPath() {
      let url =
        this.$store.getters.url +
        "/warrant/" +
        this.mandat.ID.value +
        "/stop/pdf?";
      url += "token=" + encodeURIComponent(localStorage.getItem("vue-token"));
      url += "&body=" + encodeURIComponent(this.cloture_body);
      url += "&date=" + encodeURIComponent(this.date_cloture);
      return url;
    },
    clotureMandatPdfPath() {
      let url =
        this.$store.getters.url +
        "/warrant/" +
        this.mandat.ID.value +
        "/stop/pdf?";
      url += "token=" + encodeURIComponent(localStorage.getItem("vue-token"));
      url += "&body=" + encodeURIComponent(this.mandat.note_cloture.value);
      url += "&date=" + encodeURIComponent(this.mandat.date_cloture);
      return url;
    },
    viewPdf(path) {
      this.pdfPath = "http://recuperator.cabinetdegreft.be" + path;
    },
    toDate(d) {
      return DateTime.humanDate(d);
    },
    nl2br(str) {
      return str.replace(/\n/g, "<br/>");
    },
    synopsisRowHovered(item) {
      if (this.$refs.chart) {
        this.$refs.chart.chart.xAxis[0].removePlotBand();

        this.$refs.chart.chart.xAxis[0].addPlotBand({
          color: "#AAAAAA",
          from: item.chartPeriod[0],
          to: item.chartPeriod[1],
        });
      }
    },
  },
};
</script>

<style lang="scss">
.modal-xxl {
  max-width: 90% !important;
}

.note-content p {
  margin-bottom: 1px;
}
.striked {
text-decoration: line-through;
}
.italic {
font-style: italic;
}
</style>
